export const useRouteQueryFrom = () => {
  const {
    query: { from },
  } = useRoute();
  return {
    routeQueryFrom: from as string,
  };
};
